import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import BillingInformationForm from '../../pages/registration/BillingInformation';
import CloseIcon from '@mui/icons-material/Close';

interface EditOrderBillingDialogProps {
  open: boolean;
  onClose: () => void;
  orderId: string;
}

const EditOrderBillingDialog: React.FC<EditOrderBillingDialogProps> = ({
  open,
  onClose,
  orderId,
}) => {
  const handleSave = () => {
    // This is the onSave handler that closes the dialog
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { minHeight: '400px' }
      }}
    >
      <DialogTitle>
        Edit Billing Information
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
            >
            <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <BillingInformationForm
          type="dialog"
          orderId={orderId}
          onSave={handleSave}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditOrderBillingDialog;